import { render, staticRenderFns } from "./bflesson.vue?vue&type=template&id=f8fd8824&scoped=true&"
import script from "./bflesson.vue?vue&type=script&lang=js&"
export * from "./bflesson.vue?vue&type=script&lang=js&"
import style0 from "./bflesson.vue?vue&type=style&index=0&id=f8fd8824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fd8824",
  null
  
)

export default component.exports